module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons-21fa820fc6fdaddd4574dcf6618bda84.png";